'use strict';

var attrRE = /([\w-]+)|['"]{1}([^'"]*)['"]{1}/g;

// create optimized lookup object for
// void elements as listed here: 
// http://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements
var lookup = Object.create ? Object.create(null) : {};
lookup.area = true;
lookup.base = true;
lookup.br = true;
lookup.col = true;
lookup.embed = true;
lookup.hr = true;
lookup.img = true;
lookup.input = true;
lookup.keygen = true;
lookup.link = true;
lookup.menuitem = true;
lookup.meta = true;
lookup.param = true;
lookup.source = true;
lookup.track = true;
lookup.wbr = true;
var parseTag = function parseTag(tag) {
  var i = 0;
  var key;
  var res = {
    type: 'tag',
    name: '',
    voidElement: false,
    attrs: {},
    children: []
  };
  tag.replace(attrRE, function (match) {
    if (i % 2) {
      key = match;
    } else {
      if (i === 0) {
        if (lookup[match] || tag.charAt(tag.length - 2) === '/') {
          res.voidElement = true;
        }
        res.name = match;
      } else {
        res.attrs[key] = match.replace(/['"]/g, '');
      }
    }
    i++;
  });
  return res;
};

/*jshint -W030 */
var tagRE = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;

// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
var parse = function parse(html, options) {
  options || (options = {});
  options.components || (options.components = empty);
  var result = [];
  var current;
  var level = -1;
  var arr = [];
  var byTag = {};
  var inComponent = false;
  html.replace(tagRE, function (tag, index) {
    if (inComponent) {
      if (tag !== '</' + current.name + '>') {
        return;
      } else {
        inComponent = false;
      }
    }
    var isOpen = tag.charAt(1) !== '/';
    var start = index + tag.length;
    var nextChar = html.charAt(start);
    var parent;
    if (isOpen) {
      level++;
      current = parseTag(tag);
      if (current.type === 'tag' && options.components[current.name]) {
        current.type = 'component';
        inComponent = true;
      }
      if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
        current.children.push({
          type: 'text',
          content: html.slice(start, html.indexOf('<', start))
        });
      }
      byTag[current.tagName] = current;

      // if we're at root, push new base node
      if (level === 0) {
        result.push(current);
      }
      parent = arr[level - 1];
      if (parent) {
        parent.children.push(current);
      }
      arr[level] = current;
    }
    if (!isOpen || current.voidElement) {
      level--;
      if (!inComponent && nextChar !== '<' && nextChar) {
        // trailing text node
        arr[level].children.push({
          type: 'text',
          content: html.slice(start, html.indexOf('<', start))
        });
      }
    }
  });
  return result;
};
function attrString(attrs) {
  var buff = [];
  for (var key in attrs) {
    buff.push(key + '="' + attrs[key] + '"');
  }
  if (!buff.length) {
    return '';
  }
  return ' ' + buff.join(' ');
}
function stringify(buff, doc) {
  switch (doc.type) {
    case 'text':
      return buff + doc.content;
    case 'tag':
      buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
      if (doc.voidElement) {
        return buff;
      }
      return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
  }
}
var stringify_1 = function stringify_1(doc) {
  return doc.reduce(function (token, rootEl) {
    return token + stringify('', rootEl);
  }, '');
};
var index = {
  parse: parse,
  stringify: stringify_1
};
Array.prototype.clean = function (deleteValue) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == deleteValue) {
      this.splice(i, 1);
      i--;
    }
  }
  return this;
};
function recur(obj, template, words) {
  // template = (template =='')? '$' : template;
  if (obj.type == "text") {
    obj.content = obj.content.split(/(?!$)/).map(function (char) {
      return template.replace(/\$/g, char);
    }).join("");
    if (words) {
      obj.content = obj.content.split(template.replace(/\$/g, ' ')).clean("").map(function (parsedword) {
        return words.replace(/\$/g, parsedword);
      }).join("");
    }
  }
  if (obj.children) {
    obj.children.forEach(function (tag) {
      recur(tag, template, words);
    });
  }
}
function Splitter(html, template, words) {
  var ast = index.parse(html);
  ast.forEach(function (tag) {
    recur(tag, template, words);
  });
  return index.stringify(ast);
}
module.exports = Splitter;